//  1 AI 表现力评分 2 AI 关键词评分 3 经理评分 4 多维度评分
enum EChartType {
    EXPRESSIVENESS = '1',
    KEYWORD = '2',
    MANAGER = '3',
    MULTI_DIMENSION = '4',
}

// 0 草稿 1 提交 2 保存
enum EPracticeSubmitStatus {
    DRAFT = 0,
    SUBMIT = 1,
    SAVE = 2,
}

// invite_status
// 1 ：邀请 2 ：取消邀请
enum EPracticeInviteStatus {
    INVITE = 1,
    CANCEL_INVITE = 2,
}

// 评分状态 0 未邀请 1 已邀请 2 已点评 3 已屏蔽
enum EInviteScoreStatus {
    NOT_INVITED = 0,
    INVITED = 1,
    REVIEWED = 2,
    SHIELDED = 3,
}

enum PRACTICE_TYPE {
    HOMEWORK_VIDEO = 1,
    EXAM = 2,
    CHATBOT = 3,
}

export { EChartType, PRACTICE_TYPE, EInviteScoreStatus, EPracticeSubmitStatus, EPracticeInviteStatus };
